@if (showDetailFixture) {
  <app-webinars-detail
    [analytics]="null"
    [analyticsErrorMessage]="null"
    [chatMessages]="chatMessages"
    [engagementItems]="engagementItems"
    [form]="detailForm"
    [hasHostPassword]="false"
    [hostPasswordMasked]="false"
    [isAnalyticsLoading]="false"
    [isChatLoading]="false"
    [isEngagementLoading]="false"
    [isRecurrencePreviewLoading]="false"
    [isSaving]="false"
    [pinnedChatMessageId]="null"
    [recurrencePreviewError]="null"
    [recurrencePreviewOccurrences]="[]"
    [recurrencePreviewSeries]="null"
    [registrationColumns]="registrationColumns"
    [registrations]="registrations"
    [selectedWebinar]="selectedWebinar"
  ></app-webinars-detail>
} @else if (isListLoadFailureFixture) {
  <main class="client-container">
    <section class="list-error-state" role="alert" aria-live="assertive">
      <h2 class="m-0 f-s-18 f-w-600">Unable to load webinars</h2>
      <p class="m-0">{{ listLoadErrorMessage }}</p>
      <button
        aria-label="Retry loading webinars"
        class="input-like-btn new-webinar-btn"
        color="primary"
        mat-flat-button
        type="button"
        (click)="refresh()"
      >
        Retry
      </button>
    </section>
  </main>
} @else {
  <app-webinars-list
    (create)="createWebinar()"
    (refresh)="refresh()"
    (searchChange)="onSearchTerm($event)"
    (seriesSelected)="openSeries()"
    (statusFilterChange)="setStatusFilter($event)"
    (webinarSelected)="openWebinar()"
    [filterTerm]="filterTerm"
    [series]="series"
    [seriesLoadErrorMessage]="seriesLoadErrorMessage"
    [statusCounts]="statusCounts"
    [statusFilter]="statusFilter"
    [statusMeta]="statusMeta"
    [webinars]="webinars"
  ></app-webinars-list>
}
